import { render, staticRenderFns } from "./createNewOrder.vue?vue&type=template&id=72058722&scoped=true"
import script from "./createNewOrder.vue?vue&type=script&lang=js"
export * from "./createNewOrder.vue?vue&type=script&lang=js"
import style0 from "./createNewOrder.vue?vue&type=style&index=0&id=72058722&prod&scoped=true&lang=css"
import style1 from "./createNewOrder.vue?vue&type=style&index=1&id=72058722&prod&lang=css"
import style2 from "./createNewOrder.vue?vue&type=style&index=2&id=72058722&prod&scoped=true&lang=scss"
import style3 from "./createNewOrder.vue?vue&type=style&index=3&id=72058722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72058722",
  null
  
)

export default component.exports